import { Images } from "@/constants/images"
import { getFixedT } from "@/languages/i18n"
import { toImageSrc } from "@/lib/utils"
import Image from "next/image"
import Link from "next/link"
import { TransformedStoreItem } from "../type"

const LeftSidebar = ({ store, locale }: { store: TransformedStoreItem; locale?: string }) => {
    const t = getFixedT(locale)
    // localePrefix = "as-needed" + defaultLocale "vi": chỉ prefix locale cho các
    // ngôn ngữ khác vi. Trước đây href cứng "/stores/{id}" nên trang en/cs mất
    // locale → điều hướng sai. vi giữ nguyên không prefix (khớp hành vi cũ).
    const localePrefix = locale && locale !== "vi" ? `/${locale}` : ""
    return (
        <>
            {/* Left: Image */}
            < div className="w-full flex sm:flex-row flex-col sm:gap-5 gap-2 sm:w-[48.8%]" >
                <div className="sm:w-[55.5%] w-full">
                    <div className="relative sm:h-[326px] h-[228px] w-full rounded-lg overflow-hidden">
                        <Image src={toImageSrc(store.image)} alt={store.title || "Store"} fill className="w-full h-full object-cover" />
                    </div>
                </div>
                <div className="sm:w-[44.2%] w-full flex flex-col sm:gap-4 gap-2">
                    {store.title && <h2 className="text-base leading-[24.8px] font-bold text-[#333]">{store.title}</h2>}

                    {store.contactInfo && store.contactInfo.length > 0 && (
                        <div className="flex flex-col sm:gap-3 gap-1">
                            {store.contactInfo.map((item, idx) => {
                                const isGps = item.value.startsWith(`GPS: `)
                                const isGoogleMaps = item.value.startsWith("Google Maps:")

                                let label = ""
                                let value = item.value

                                if (isGps) {
                                    label = "GPS:"
                                    value = item.value.replace("GPS:", "").trim()
                                } else if (isGoogleMaps) {
                                    label = "Google Maps:"
                                    value = item.value.replace("Google Maps:", "").trim()
                                }

                                const content = (
                                    <>
                                        {idx < 3 && (
                                            <div className="relative w-[13px] h-[18px]">
                                                <Image src={Images.iconLocationStore} fill alt="icon-location" className="w-full h-full" />
                                            </div>
                                        )}
                                        {label ? (
                                            <>
                                                <span className="text-[14px] leading-[21.7px] font-normal text-[#333]">{label} </span>
                                                <span className={`text-[14px] leading-[21.7px] font-normal ${isGps || isGoogleMaps ? "text-[#20afff] hover:text-[#17a148] transition-colors" : "text-[#333]"}`}>
                                                    {value}
                                                </span>
                                            </>
                                        ) : (
                                            <span className="text-[14px] leading-[21.7px] font-normal text-[#333]">{item.value}</span>
                                        )}
                                    </>
                                )

                                if (item.link) {
                                    const isExternal = item.link.startsWith("http://") || item.link.startsWith("https://")
                                    return (
                                        <Link
                                            key={idx}
                                            href={item.link}
                                            className="flex items-center gap-2"
                                            target={isExternal ? "_blank" : undefined}
                                            rel={isExternal ? "noopener noreferrer" : undefined}
                                        >
                                            {content}
                                        </Link>
                                    )
                                }

                                return (
                                    <div key={idx} className="flex items-center gap-2">
                                        {content}
                                    </div>
                                )
                            })}
                        </div>
                    )}
                    <Link
                        href={`${localePrefix}/stores/${store.id}`}
                        className="flex sm:mx-0 mx-auto items-center justify-center text-[14px] leading-9 font-normal bg-[#00A651] text-white px-[18px] rounded w-fit hover:text-white btn-zoom-effect"
                    >
                        {t("Visit store")}
                    </Link>
                </div>
            </div >
        </>
    )
}

export default LeftSidebar